import { useRouter } from 'next/router';
import React from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { CoursesSectionContainer, Title, CourseList } from './style';

import { CourseCard } from '@components/molecules/academicLandingPage/courseCard';
import { useDegreeUniversityLandingPageData, useUniversityInformation } from '@helpers/use';
import { sanitize } from '@helpers/utils';
import { StatusDegreeUniversity } from '@interfaces/university';

export const CoursesSection = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const universityIdName = router.query.universityIdName as string;
  const { landingPage } = useUniversityInformation(universityIdName);
  const { degreeUniversityLandingPage } = useDegreeUniversityLandingPageData(landingPage?.id);

  return (
    <CoursesSectionContainer>
      <Title>{t('degree_landing_page.course_section.university.title')}</Title>
      <CourseList>
        {degreeUniversityLandingPage
          ?.filter((item) => item.status !== StatusDegreeUniversity.Draft)
          .map((item) => (
            <CourseCard
              key={`${item.aliasName}`}
              coursePreview={item.thumbnailImageUrl}
              isActive={item.status !== StatusDegreeUniversity.ComingSoon}
              majorSubject={item?.major?.majorSubject}
              majorName={item?.major?.name}
              degree={item.aliasName}
              degreeName={item.name}
              courseUrl={item.url}
              universityIdName={universityIdName}
            />
          ))}
      </CourseList>
      <Typography
        textAlign="center"
        fontSize="18px"
        lineHeight="22px"
        fontWeight={500}
        color="#00000099"
        marginBottom={{ xs: '46px', md: '106px' }}
      >
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={sanitize(landingPage?.annotation || '')}
        />
      </Typography>
    </CoursesSectionContainer>
  );
};
